'use client';

import tinycolor from "../../../external/tinycolor2/esm/tinycolor.js";
const getLightness = (primaryColor) => tinycolor(primaryColor).toHsl().l * 100;
export {
  getLightness
};
